window.AlumniConnect.Helpers.Style = {
  PublicHeaderMarginBottom: 40,
};
